import { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { MDSLink } from "@/mds";
import { TrackedEvent, trackEvent } from "@/domains/metrics";
import { windowModule } from "@/modules/window";
import { useAppStore } from "@/store";
import { ApiKeyItemList } from "@/pages/integrations/api/integrations-api-page-content-list";
import {
  SettingsIntegrationPageWrapper,
  SettingsIntegrationHeader,
  SettingsIntegrationScrollableArea,
  SettingsIntegrationSection,
  SettingsIntegrationBenefitCard,
} from "@/pages/settings/components/settings-integration-layout";

export const SettingsApiKeysPage = observer(() => {
  const { store } = useAppStore();
  const isConnected = store.apiKeys.allActiveApiKeys.length > 0;

  const handleClickDevDocsLink = useCallback(() => {
    trackEvent(TrackedEvent.ApiDevDocsLinkClick);
    windowModule.openInNewTab({ url: new URL("https://docs.mem.ai") });
  }, []);

  const benefitPoints = [
    "API keys help you connect Mem with other apps and services you use.",
    <>
      Whether you&apos;re building custom integrations or using third-party tools, our{" "}
      <MDSLink onPress={handleClickDevDocsLink}>API Docs</MDSLink> will guide you through the
      process.
    </>,
    "Remember to treat your API keys like passwords - keep them private and secure.",
  ];

  return (
    <SettingsIntegrationPageWrapper>
      <SettingsIntegrationHeader
        breadcrumb="Developer"
        title="API Keys"
        isConnected={isConnected}
      />
      <SettingsIntegrationScrollableArea>
        <SettingsIntegrationSection>
          <SettingsIntegrationBenefitCard points={benefitPoints} variant="bullet" />
        </SettingsIntegrationSection>

        <SettingsIntegrationSection>
          <ApiKeyItemList />
        </SettingsIntegrationSection>
      </SettingsIntegrationScrollableArea>
    </SettingsIntegrationPageWrapper>
  );
});
